import { render, staticRenderFns } from "./IconThumbsUp.vue?vue&type=template&id=75f3641e&"
import script from "./IconThumbsUp.vue?vue&type=script&lang=js&"
export * from "./IconThumbsUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f3641e')) {
      api.createRecord('75f3641e', component.options)
    } else {
      api.reload('75f3641e', component.options)
    }
    module.hot.accept("./IconThumbsUp.vue?vue&type=template&id=75f3641e&", function () {
      api.rerender('75f3641e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconThumbsUp.vue"
export default component.exports